<template>
  <div class="dt-time-picker">
    <IntPicker :value="hourValue" @changed="onHourChange" />
    <div class="separator ut-flex ut-rowcen">:</div>
    <IntPicker :value="minValue" @changed="onMinChange" />
  </div>
</template>
<script>
import {
  getValidHour,
  getValidMinSec,
  padWithZero,
} from "../../utility/calendar";
import IntPicker from "./int-picker";

export default {
  components: {
    IntPicker,
  },
  props: {
    value: {
      type: String,
    },
  },
  computed: {
    hourValue() {
      const hv = this.value?.split(":")?.[0];
      if (isNaN(hv)) {
        return "00";
      } else {
        return hv || "00";
      }
    },
    minValue() {
      const mv = this.value?.split(":")?.[1];
      if (isNaN(mv)) {
        return "00";
      } else {
        return mv || "00";
      }
    },
  },
  data() {
    return {};
  },
  methods: {
    format(value) {
      return `${value}`.padStart(2, "0");
    },
    onHourChange(value) {
      value = getValidHour(value);
      this.$emit(
        "changed",
        `${padWithZero(value)}:${padWithZero(this.minValue)}`
      );
    },
    onMinChange(value) {
      let hourValue = this.hourValue;
      if (value > 59) {
        hourValue = getValidHour(+hourValue + 1);
      } else if (value < 0) {
        hourValue = getValidHour(+hourValue - 1);
      }
      value = getValidMinSec(value);
      this.$emit("changed", `${padWithZero(hourValue)}:${padWithZero(value)}`);
    },
    //MARK: Methods
  },
};
</script>

<style lang="scss">
.dt-time-picker {
  width: 100%;
  background: white;
  padding: 8px 16px;

  display: flex;
  flex-direction: row;
  justify-content: center;
  .separator {
    min-width: 16px;
    min-height: 100%;
  }
}
</style>